import { render } from "./SelectedOrderInfoComponent.vue?vue&type=template&id=b397b610&scoped=true"
import script from "./SelectedOrderInfoComponent.vue?vue&type=script&lang=js"
export * from "./SelectedOrderInfoComponent.vue?vue&type=script&lang=js"

import "./SelectedOrderInfoComponent.vue?vue&type=style&index=0&id=b397b610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b397b610"]])

export default __exports__